import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange"],
    _excluded2 = ["input", "meta", "label", "validateOnMount", "helperText", "description", "FormItemProps", "isRequired", "range", "min", "max", "isDisabled", "isReadOnly"];
import React, { useEffect } from 'react';
import AntSlider from "antd/es/slider/index.js";
import useFieldApi from "@data-driven-forms/react-form-renderer/use-field-api";
import FormGroup from '../form-group';

var Slider = function Slider(props) {
  var _useFieldApi = useFieldApi(props),
      _useFieldApi$input = _useFieldApi.input,
      value = _useFieldApi$input.value,
      onChange = _useFieldApi$input.onChange,
      input = _objectWithoutProperties(_useFieldApi$input, _excluded),
      meta = _useFieldApi.meta,
      label = _useFieldApi.label,
      validateOnMount = _useFieldApi.validateOnMount,
      helperText = _useFieldApi.helperText,
      description = _useFieldApi.description,
      FormItemProps = _useFieldApi.FormItemProps,
      isRequired = _useFieldApi.isRequired,
      range = _useFieldApi.range,
      _useFieldApi$min = _useFieldApi.min,
      min = _useFieldApi$min === void 0 ? 0 : _useFieldApi$min,
      _useFieldApi$max = _useFieldApi.max,
      max = _useFieldApi$max === void 0 ? 100 : _useFieldApi$max,
      isDisabled = _useFieldApi.isDisabled,
      isReadOnly = _useFieldApi.isReadOnly,
      rest = _objectWithoutProperties(_useFieldApi, _excluded2);

  useEffect(function () {
    if (range === true && (!value || !Array.isArray(value))) {
      onChange([min, max]);
    }
  }, [min, max, range, value, onChange]);
  return /*#__PURE__*/React.createElement(FormGroup, {
    label: label,
    meta: meta,
    validateOnMount: validateOnMount,
    helperText: helperText,
    description: description,
    FormItemProps: FormItemProps,
    isRequired: isRequired
  }, /*#__PURE__*/React.createElement(AntSlider, _extends({
    disabled: isDisabled || isReadOnly,
    onChange: onChange
  }, input, {
    value: range === true && !Array.isArray(value) ? [min, max] : value,
    range: range,
    min: min,
    max: max
  }, rest)));
};

export default Slider;